import * as React from "react";

// Material UI
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import Fab from "@material-ui/core/Fab";

// Store
import { CreateListsStore } from "stores";

// Utils
import * as Icons from "core/utils/Icons";

// Localization
import { strings } from "core/localizedStrings";

export const AddButton = (props: any) => (
    <Tooltip title={strings.addCards} placement="bottom">
        <Fab
            color="primary"
            onClick={props.onClick}
            style={{
                width: 40,
                height: 40,
            }}
        >
            <Icons.Add color="secondary" />
        </Fab>
    </Tooltip>
);

interface BottomButtonProps extends React.Props<any> {
    zIndex?: number;
}

export const BottomButton = (props: BottomButtonProps) => (
    <div className="full-width" style={{ position: "absolute", bottom: 25, zIndex: props.zIndex ? props.zIndex : 1 }}>
        <div style={{ paddingLeft: 20, paddingRight: 20 }}>{props.children}</div>
    </div>
);

interface CreateCardsButtonsProp extends React.Props<any> {
    store: CreateListsStore;
    selectedItemsCount: number;
    onSelectionComplete: () => void;
}

export const CreateCardsButton = (props: CreateCardsButtonsProp) => {
    let createCardsButtonText = strings.createCardFromSelectedImage;

    if (props.selectedItemsCount > 1) {
        createCardsButtonText = strings.formatString(
            strings.createCardsFromSelectedImages,
            props.selectedItemsCount
        ) as string;
    }

    const onAddSelectedImagesClicked = () => {
        props.store.editNextSelectedImageForAdd();
        props.onSelectionComplete();
    };

    return (
        <Button
            fullWidth={true}
            disabled={props.selectedItemsCount == 0}
            variant="contained"
            color="primary"
            onClick={onAddSelectedImagesClicked}
        >
            {createCardsButtonText}
        </Button>
    );
};
